import { Department } from "../types/user";
import { FilterDict } from "../types/filter";

export const getProgressFilterDict = (
  department: Department[],
  directory: string
): FilterDict => ({
  department: {
    type: "select",
    label: "구분",
    options: [
      { value: "", label: "전체" },
      { value: "life", label: "생활스포츠" },
      { value: "pro", label: "전문스포츠" },
    ],
    disabled: department.length === 1,
    defaultValue: department.length === 1 ? department[0] : "",
    placeholder: "구분",
  },
  course: {
    type: "select",
    label: "과정",
    options: [
      { value: "", label: "전체" },
      { value: "special", label: "특별과정" },
      { value: "general", label: "일반과정" },
    ],
  },
  timetable: {
    type: "select",
    label: "시간 분반",
    options: [
      { value: "", label: "전체" },
      { value: "weekends", label: "주말" },
      { value: "weekdays", label: "주중" },
      { value: "weekdays-b", label: "주중B" },
    ],
  },
  training_type: {
    type: "select",
    label: "현장실습 유형",
    options: [
      { value: "", label: "전체" },
      { value: "mandatory", label: "지정" },
      { value: "individual", label: "개별" },
      { value: "incumbent", label: "현직" },
    ],
    disabled: directory.includes("현장실습"),
    defaultValue: (() => {
      if (directory.includes("섭외기관")) return "individual";
      if (directory.includes("매칭")) return "mandatory";
      if (directory.includes("근무처")) return "incumbent";
      return "";
    })(),
  },
  name__contains: {
    type: "input",
    label: "이름",
  },
  user_code__contains: {
    type: "input",
    label: "학생 코드",
  },
});
